import React from 'react';
import { Text, Link, Image } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';
import clsx from 'clsx';

const GradientBox = (props) => {
  const planOffers = props?.fields?.items;
  return (
    <div className={clsx('plans', 'add-margins', props?.params?.Styles)}>
      <div className="container">
        <div className="row">
          <div className="col-md-7">
            <h2>
              <Text field={props?.fields?.heading} />
            </h2>
            <p>
              <Text field={props?.fields?.text} />
            </p>
            {props?.fields?.link && props?.fields?.link?.value?.text ? (
              <Link field={props?.fields?.link} className="button icon-link" />
            ) : null}
          </div>
          <div className="col-md-5">
            <div className="plans__payments">
              {planOffers &&
                planOffers?.map((data, index) => {
                  return (
                    <div key={index} className="holder">
                      <Image field={data?.fields?.icon} />
                      <p>
                        <Text field={data?.fields?.title} />
                      </p>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GradientBox;
